module.exports = __webpack_public_path__ + "media/images/image2-673c685c8ce50a74dbd85cac938e5702.png";